import Vue from "vue";
import VueI18n from "vue-i18n";
import Deploy from "./config/config";

const merge = require("webpack-merge");

Vue.use(VueI18n);
const { defaultLang } = Deploy;
function loadLocaleMessages() {
  const locales = require.context("./language/local", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const common = require.context("./language/common", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const localMessages = {};
  const commonMessages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      localMessages[locale] = locales(key);
    }
  });
  common.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      commonMessages[locale] = common(key);
    }
  });
  const mergeLanguage = merge(commonMessages, localMessages);
  const lkey = localLang || defaultLang;
  window.brLang = mergeLanguage[lkey];
  return mergeLanguage;
}

const localLang = window.localStorage.getItem("hisLang");
if (!localLang) {
  window.localStorage.setItem("hisLang", defaultLang);
  window.localStorage.setItem("lang", defaultLang);
}

const i18n = new VueI18n({
  locale: localLang || defaultLang,
  fallbackLocale: localLang || defaultLang,
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
});
window.$i18n = i18n;
export default i18n;
